<template>
    <div>
        <ui-input
            v-model="data.order"
            type="number"
            label="Order"
            name="order"
        />

        <ui-select
            v-model="data.type"
            :options="types"
            label="Type"
            name="data[type]"
        />

        <div v-if="allowedFields !== []">
            <ui-input
                v-model="data.header"
                v-if="allowedFields.includes('header')"
                label="Header"
                name="data[header]"
            />

            <ui-editor
                v-model="data.text"
                v-if="allowedFields.includes('text')"
                class="mb-4"
                name="data[text]"
                label="Tekst"
            ></ui-editor>

            <ui-input
                v-model="data.videoUrl"
                v-if="allowedFields.includes('video_url')"
                type="url"
                label="Video URL"
                name="data[video_url]"
            />

            <div
                v-if="allowedFields.includes('image')"
                class="
                d-flex
                flex-column
                flex-md-row
                align-items-md-center
                justify-content-md-between
                mb-4
            "
            >
                <ui-avatar
                    size="medium"
                    :src="imageUrl"
                ></ui-avatar>

                <ui-input-file
                    label="Afbeelding"
                    name="data[image]"
                    :optional="optionalFiles"
                />

                <ui-input-checkbox
                    v-if="imageUrl !== ''"
                    name="unlink_image"
                    id="unlink_image"
                    label="Verwijder afbeelding"
                ></ui-input-checkbox>
            </div>

            <div
                v-if="allowedFields.includes('audio')"
                class="
                d-flex
                flex-column
                flex-md-row
                align-items-md-center
                justify-content-md-between
                mb-4
            "
            >
                <ui-input-file
                    v-if="allowedFields.includes('audio')"
                    label="Audiofragment"
                    name="data[audio]"
                    :optional="optionalFiles"
                />

                <ui-input-checkbox
                    v-if="audioUrl !== ''"
                    name="unlink_audio"
                    id="unlink_audio"
                    label="Verwijder audio"
                ></ui-input-checkbox>
            </div>
        </div>
    </div>
</template>

<script>
import UiAvatar from '../ui/avatar.vue';
import UiEditor from '../ui/editor.vue';
import UiInputCheckbox from '../ui/input-checkbox.vue';
import UiSelect from '../ui/select.vue';
import UiTextarea from '../ui/textarea.vue';
import UiInput from '../ui/input.vue';
import UiInputFile from '../ui/input-file.vue';

export default {
    name: 'MindProblemStatementSection',
    components: {
        UiAvatar,
        UiEditor,
        UiInputCheckbox,
        UiSelect,
        UiTextarea,
        UiInput,
        UiInputFile,
    },
    data() {
        return {
            data: {
                order: this.order,
                type: this.type,
                header: this.header,
                text: this.text,
                videoUrl: this.videoUrl,
            },
        };
    },
    props: {
        optionalFiles: {
            type: Boolean,
            default: false,
        },
        order: {
            type: Number,
            required: true,
        },
        type: {
            type: String,
            default: '',
        },
        header: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        audioUrl: {
            type: String,
            default: '',
        },
        imageUrl: {
            type: String,
            default: '',
        },
        videoUrl: {
            type: String,
            default: '',
        },
        types: {
            type: Array,
            required: true,
        },
    },
    computed: {
        allowedFields() {
            return this.types.find((type) => type.value === this.data.type)?.allowedFields || [];
        },
    },
};
</script>
